export const VISIBLE_BANNER_AREA_PERCENTS = 100
export const VIEWING_TIME = 2000
export const VISIBLE_BANNER_AREA_PERCENTS_DEMO = 50
export const LPU_AD_ELEMENT_CLASS_SELECTOR = '.lpu_ad'
